import { render, staticRenderFns } from "./SpeechAndLanguage.vue?vue&type=template&id=7742d424"
import script from "./SpeechAndLanguage.vue?vue&type=script&lang=js"
export * from "./SpeechAndLanguage.vue?vue&type=script&lang=js"
import style0 from "./SpeechAndLanguage.vue?vue&type=style&index=0&id=7742d424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports